export default __webpack_public_path__ + "static/media/home-banner.f6696cc6.png";